// import React, { useEffect, useRef, useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import Select from 'react-select';
// import { loadDepartmentDropdownData, loadReportingDesignationDropdownData, loadSingleDesignationData, postDashboardCategoryDatas, postDesignationDatas, postDynamicDashboardDatas } from "../../../redux/action";
// import * as HeaderAuthentication from '../../HeaderAuthentication'
// import { useDispatch, useSelector } from "react-redux";
// import { ADDED_BY_ID } from "../../../Constants";
// import attachmentImg from '../../../assets/images/attachmentImg.svg';
// import { useNavigate } from "react-router-dom";

// const AddDashboardCategory = (props) => {

//     const dispatch = useDispatch();
//     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//     const singleDashboardCategoryData = props.singleDashboardCategoryData;
//     const dashboardCategoryId = props.dashboardCategoryId;
//     const companyId = signInDetails?.[0]?.CompanyID || null;
//     console.log(singleDashboardCategoryData, 'singleDashboardCategoryData')
//     // console.log(getDynamicDashboardCategoryDropdownData, 'getDynamicDashboardCategoryDropdownData')

//     const [errors, setErrors] = useState({});

//     const [dashboardCategoryData, setDashboardCategoryData] = useState({
//         CompanyID: companyId,
//         DashboardCategoryName: "",
//         AddedByID: ADDED_BY_ID,
//     });


//     const handleInputChange = (event) => {
//         const { name, value } = event.target;

//         setDashboardCategoryData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));

//         // Remove error message when user starts typing
//         setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: value.trim() ? "" : prevErrors[name],
//         }));
//     };

//     const handleSelectChange = (selectedOption, action) => {
//         setDashboardCategoryData(prevData => ({
//             ...prevData,
//             [action.name]: selectedOption ? selectedOption.value : null // Store only the value
//         }));
//         setErrors(prevErrors => ({ ...prevErrors, [action.name]: "" }));
//     };

//     useEffect(() => {
//         if (dashboardCategoryId && singleDashboardCategoryData?.length > 0) {
//             const dashboardData = singleDashboardCategoryData[0]; // Get the first object from array
//             const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

//             setDashboardCategoryData({
//                 // CompanyID: dashboardData.CompanyID || null,
//                 CompanyID: signInDetails?.[0]?.CompanyID || null,
//                 DashboardCategoryID: dashboardCategoryId || null,
//                 DashboardCategoryName: dashboardData.DashboardLibraryName || "",
//                 AddedByID: ADDED_BY_ID,
//                 StatusID: dashboardData.StatusID || null,
//             });
//         } else {
//             setDashboardCategoryData({
//                 CompanyID: null,
//                 DashboardCategoryID: null,
//                 DashboardCategoryName: "",
//                 AddedByID: ADDED_BY_ID,
//                 StatusID: null,
//             });
//         }
//     }, [DashboardCategoryID, singleDashboardCategoryData]);


//     const validateForm = () => {
//         let tempErrors = {};
//         // if (!dynamicDashboardData.CompanyID) tempErrors.CompanyID = "Company is required";
//         if (!dynamicDashboardData.DashboardLibraryName) tempErrors.DashboardLibraryName = "Dashboard Category Name is required";

//         setErrors(tempErrors);
//         return Object.keys(tempErrors).length === 0;
//     };

//     const addDynamicDashboardData = (e) => {
//         e.preventDefault();
//         if (validateForm()) {
//             const updatedDynamicDashboardData = { ...dynamicDashboardData, IsFileUpdated: imgChange, CompanyID: signInDetails?.[0]?.CompanyID ?? null };
//             let requestOption = {
//                 method: "POST",
//                 mode: "cors",
//                 headers: HeaderAuthentication.postExcomatixAuth,
//                 body: JSON.stringify(updatedDynamicDashboardData),
//             };
//             dispatch(postDashboardCategoryDatas(requestOption, props.handleCloseModal, props.fetchDashboardCategory, dashboardId, imgChange, setImgChange,));
//             console.log("Submitting Data:", dynamicDashboardData);
//         }
//     };

//     return (
//         <>
//             <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal'>
//                 <Modal.Header closeButton>
//                     <Modal.Title>{dashboardId ? "Edit Dashboard Category" : "Add Dashboard Category"}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Row className='customer-form-fields'>
//                         <Col>
//                             <Row>
//                                 <Col md={12}>
//                                     <div>
//                                         <label className="p-1">Dashboard Category Name</label>
//                                         <Form.Control
//                                             type="text"
//                                             name="DashboardLibraryName"
//                                             value={dynamicDashboardData.DashboardLibraryName}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>
//                                     {errors.DashboardLibraryName && <div className="text-danger">{errors.DashboardLibraryName}</div>}
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 {dashboardCategoryId && <Col md={4}>
//                                     <div>
//                                         <label>Status</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             options={props.enablingOptions}
//                                             placeholder="Select"
//                                             name="Status"
//                                             value={props.enablingOptions.find(option => option.value === dynamicDashboardData.StatusID) || null}
//                                             onChange={handleSelectChange}
//                                             menuPosition="fixed"
//                                             menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
//                                         />
//                                     </div>
//                                 </Col>}
//                             </Row>
//                         </Col>
//                     </Row>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
//                     <SBSaveUpdateBtn btnName="Submit" onClickEffect={addDynamicDashboardData} />
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// }

// export default AddDashboardCategory;




import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from "react-select";
import { postDashboardCategoryDatas } from "../../../redux/action";
import * as HeaderAuthentication from "../../HeaderAuthentication";
import { useDispatch } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AddDashboardCategory = (props) => {
  const dispatch = useDispatch();
  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
  const singleDashboardCategoryData = props.singleDashboardCategoryData;
  const dashboardCategoryId = props.dashboardCategoryId;
  const companyId = signInDetails?.[0]?.CompanyID || null;
  const dataLoading = props.dataLoading;

  const [errors, setErrors] = useState({});
  const [dashboardCategoryData, setDashboardCategoryData] = useState({
    CompanyID: companyId,
    DashboardCategoryName: "",
    AddedByID: ADDED_BY_ID,
    StatusID: null,
  });

  // Input change handler
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDashboardCategoryData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : prevErrors[name],
    }));
  };

  // Dropdown change handler
  const handleSelectChange = (selectedOption, action) => {
    setDashboardCategoryData((prevData) => ({
      ...prevData,
      [action.name]: selectedOption ? selectedOption.value : null,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [action.name]: "" }));
  };

  // Populate data if editing
  useEffect(() => {
    if (dashboardCategoryId && singleDashboardCategoryData?.length > 0) {
      const dashboardData = singleDashboardCategoryData[0];
      setDashboardCategoryData({
        CompanyID: companyId,
        DashboardCategoryID: dashboardCategoryId || null,
        DashboardCategoryName: dashboardData.DashboardCategoryName || "", // ✅ fixed
        AddedByID: ADDED_BY_ID,
        StatusID: dashboardData.StatusID || null,
      });
    } else {
      setDashboardCategoryData({
        CompanyID: companyId,
        DashboardCategoryID: null,
        DashboardCategoryName: "",
        AddedByID: ADDED_BY_ID,
        StatusID: null,
      });
    }
  }, [dashboardCategoryId, singleDashboardCategoryData, companyId]);

  // Validation
  const validateForm = () => {
    let tempErrors = {};
    if (!dashboardCategoryData.DashboardCategoryName)
      tempErrors.DashboardCategoryName = "Dashboard Category Name is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Submit
  const addDashboardCategory = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const updatedData = {
        ...dashboardCategoryData,
        CompanyID: signInDetails?.[0]?.CompanyID ?? null,
      };

      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: HeaderAuthentication.postExcomatixAuth,
        body: JSON.stringify(updatedData),
      };

      dispatch(
        postDashboardCategoryDatas(
          requestOption,
          props.handleCloseModal,
          props.fetchDashboardCategory,
          dashboardCategoryId
        )
      );

      console.log("Submitting Data:", updatedData);
    }
  };

  return (
    <Modal
      show={props.open}
      onHide={props.handleCloseModal}
      className="add-role-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {dashboardCategoryId ? "Edit Dashboard Category" : "Add Dashboard Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="customer-form-fields">
          <Col>
            <Row>
              <Col md={12}>
                <div>
                  <label className="p-1">Dashboard Category Name</label>
                  {dataLoading ? (
                    <Skeleton height={38} />
                  ) : (
                    <Form.Control
                      type="text"
                      name="DashboardCategoryName" // ✅ fixed
                      value={dashboardCategoryData.DashboardCategoryName}
                      onChange={handleInputChange}
                    />)}
                </div>
                {errors.DashboardCategoryName && (
                  <div className="text-danger">{errors.DashboardCategoryName}</div>
                )}
              </Col>
            </Row>

            {dashboardCategoryId && (
              <Row>
                <Col md={4}>
                  <div>
                    <label>Status</label>
                    {dataLoading ? (
                      <Skeleton height={38} />
                    ) : (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={props.enablingOptions}
                        placeholder="Select"
                        name="StatusID" // ✅ fixed to match state
                        value={
                          props.enablingOptions.find(
                            (option) => option.value === dashboardCategoryData.StatusID
                          ) || null
                        }
                        onChange={handleSelectChange}
                        menuPosition="fixed"
                        menuShouldScrollIntoView={false}
                      />)}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
        <SBSaveUpdateBtn btnName="Submit" onClickEffect={addDashboardCategory} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddDashboardCategory;
